let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6M7E7")).then(() => parcelRequire('DaM6a'));